export const sortSelectedOption = (option = [], value = []) => {
  const unselectedOption = option.filter(a => !value.some(b => a.value === b.value));
  return unselectedOption;
};
